define(["require", "exports", "../number"], function (require, exports, number_1) {
    "use strict";
    exports.__esModule = true;
    function isValidNumberVal($input) {
        var val = number_1.valAsNumber($input.val());
        var min = number_1.valAsNumber($input.attr('min'));
        var max = number_1.valAsNumber($input.attr('max'));
        var valid = (isNaN(min) || min <= val) && (isNaN(max) || val <= max);
        if (!isNaN(val) && !valid) {
            return {
                valid: false,
                message: "please set value between " + min + "-" + max
            };
        }
        return {
            valid: true
        };
    }
    exports.isValidNumberVal = isValidNumberVal;
    function validateNumberRange($input) {
        var result = isValidNumberVal($input);
        if (!result.valid) {
            $("<span class=\"error required\">" + result.message + "</span>").insertAfter($input);
        }
        else {
            $input.next('span.error').remove();
        }
    }
    exports.validateNumberRange = validateNumberRange;
    function isValidNumberField($input) {
        return $input.next('span.error').length === 0;
    }
    exports.isValidNumberField = isValidNumberField;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/jquery-plugins/numberInput.js
// module id = 55
// module chunks = 0